export const SET_CANCELLED_TRIPS = 'SET_CANCELLED_TRIPS';

export const actionSetCancelledTrips = trips => ({
    type: SET_CANCELLED_TRIPS,
    payload: trips
})
